import { Box } from '@wix/design-system';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { selectIsLiveChat, selectIsLocked } from '../../../common/selectors/chat';
import { renderModel } from '../../../util/renderModel';
import { EndLiveChatButton } from '../EndLiveChatButton';
import { MuteButton } from '../MuteButton';
import { ResetButton } from '../ResetButton';
import { headerFullPageDataHooks } from './HeaderFullPage.dataHooks';

const isMobile = renderModel.isMobile();

export const HeaderFullPageActions: FC = () => {
  const isChatLocked = useSelector(selectIsLocked);
  const isLiveChat = useSelector(selectIsLiveChat);

  if (isLiveChat) {
    return (
      <Box gap={isMobile ? 1 : 2}>
        <MuteButton />
        <EndLiveChatButton />
      </Box>
    );
  }

  return (
    <Box>
      <ResetButton
        skin="light"
        priority="secondary"
        disabled={isChatLocked}
        dataHook={headerFullPageDataHooks.resetChatButton()}
      />
    </Box>
  );
};
